import React from 'react';
import PropTypes from 'prop-types';
import { Steps } from 'antd';
import styles from './StepProgress.module.css';

const { Step } = Steps;

/**
 * StepProgress - Displays wizard progress indicator
 *
 * Extracted from ReportWriterV2 to improve modularity
 */
const StepProgress = ({ currentStep }) => {
  const steps = [
    { title: 'Select Type' },
    { title: 'Choose Mode' },
    { title: 'Fill Report' },
    { title: 'Finalize and Save' }
  ];

  return (
    <div className={styles.progressContainer}>
      <Steps current={currentStep} size="small" className={styles.stepsWrapper}>
        {steps.map((step, index) => (
          <Step key={index} title={step.title} />
        ))}
      </Steps>
    </div>
  );
};

StepProgress.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

export default StepProgress;
